import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumns: [],
    allOccupationsMapping : [],
    allSeniorityMapping : []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.MAP_POSITIONS_NEXT_STEP: 
          return {...state,currentStep : state.currentStep + 1};
        case actionTypes.MAP_POSITIONS_PREVIOUS_STEP :
          return {...state,currentStep : state.currentStep - 1};
        case actionTypes.MAP_POSITIONS_UPLOAD_FILE_SUCCESS :
        return {...state, allColumns : action.val.columns, rowData : action.val.data, file: action.val.file};
        case actionTypes.MAP_POSITIONS_MATCH_COLUMN_SUCCESS :
        return {...state, matchedColumns : action.val};
        case actionTypes.MAP_POSITIONS_SAVE_POSITIONS_MAPPING :
          return {...state, allOccupationsMapping : action.val.occupations, 
            allSeniorityMapping : action.val.seniority};
        default:
          break;
    }
    return state;
}